import { BarcodeReader as ActualBarcodeReader } from 'core/ui-next';
import { useIsOnTop } from 'core/ui-next/modal/ModalHooks';
import React from 'react';

export type BarcodeReader = {
	start: () => void;
	stop: () => void;
};

function createBarcodeReader(onBarcodeRead: (barcode: string) => void): BarcodeReader {
	let dispose: Nullable<() => void> = null;

	return {
		start: () => {
			dispose?.();
			dispose = ActualBarcodeReader.start(onBarcodeRead);
		},
		stop: () => {
			dispose?.();
			dispose = null;
		}
	};
}

export function useBarcodeReaderRef(
	onBarcodeRead: (barcode: string) => void
): React.RefObject<Nullable<BarcodeReader>> {

	const barcodeReader = React.useRef<BarcodeReader>(null);
	const onBarcodeReadRef = React.useRef(onBarcodeRead);
	const isOnTop = useIsOnTop();

	React.useEffect(() => {
		onBarcodeReadRef.current = onBarcodeRead;
	}, [onBarcodeRead]);

	React.useEffect(() => {
		barcodeReader.current = createBarcodeReader(onBarcodeReadRef.current);
		return () => barcodeReader.current?.stop();
	}, []);

	React.useEffect(() => {
		if (isOnTop)
			barcodeReader.current?.start();
		else
			barcodeReader.current?.stop();
	}, [isOnTop]);

	return barcodeReader;
}